var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2533 10.7303C12.1381 9.61425 10.6276 9 9.00008 9C7.37258 9 5.86208 9.61425 4.74683 10.7303L5.80733 11.7907C6.63983 10.9582 7.77308 10.4992 9.00008 10.4992C10.2271 10.5 11.3603 10.9582 12.1928 11.7907L13.2533 10.7303Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3278 8.469C11.8988 5.03925 6.1021 5.03925 2.6731 8.469L3.7336 9.5295C6.58885 6.67425 11.4121 6.67425 14.2673 9.5295L15.3278 8.469Z",
    fill: "#BBBBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15C9.82843 15 10.5 14.3284 10.5 13.5C10.5 12.6716 9.82843 12 9 12C8.17157 12 7.5 12.6716 7.5 13.5C7.5 14.3284 8.17157 15 9 15Z",
    fill: "#BBBBBB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9305_7030)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.3354,
    y1: 6.00623,
    x2: 8.00623,
    y2: 14.6646,
    stroke: "#BBBBBB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9305_7030",
    x: 7.2561,
    y: 4.25607,
    width: 5.82959,
    height: 11.1587,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9305_7030"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9305_7030",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOffline);
export default __webpack_public_path__ + "static/media/wifi_Offline.a4b7c7dc34b2a1e9396a815736818235.svg";
export { ForwardRef as ReactComponent };